import { Component, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HelperService } from 'src/app/services/helper.service';
import { LookupService } from 'src/app/services/lookup.service';
import { QuoteService } from 'src/app/services/quote.service';
import { QuoteApplicationStatus, RTMPApplicationStatus } from '../../core/constants/status.constants'
import { Observable, forkJoin } from 'rxjs';
import { FileService } from 'src/app/services/file.service';
import { PaymentService } from 'src/app/services/payment.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent {
  @ViewChild('payment', { static: false }) modalContent!: TemplateRef<any>;

  id: number = 0;
  quoteId: number = 0;
  paymentNumber: string = '';
  paymentId: number = 0;
  modalReference: any;
  obligationPayment: any = {};
  //public fgPayment: UntypedFormGroup;
  application: any = {};
  quoteStatement: any = {};
  quoteCredits: any[] = [];
  totalPinnedBottomRowData: any[] = [];
  creditsGridColumns: any[] = [];
  oldPaymentsGridColumns: any[] = [];
  newPaymentsGridColumns: any[] = [];
  paymentsGridColumns: any[] = [];
  isRFQAfterAmendment = false;
  bcfPaymentFee: number = 0;
  gridApi: any;
  public fileTypes: any = [];
  public FILE_TYPE_CODE: string = 'QTEF';
  public lgas: any = [];
  public developmentTypes: any = [];
  payerSameAsApplicant: boolean = false;
  payer : any = {};
  isCertificateMailSent: boolean = false;


  preparationDate: string = '';

  defaultColDef: any = {
    resizable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    flex: 1,
    minWidth: 100
  };
  applicant: any;
  
  constructor(private modalService: NgbModal,private lookup: LookupService, private fileService: FileService,
    private quoteService: QuoteService, private paymentService: PaymentService,
    private helperService: HelperService, private router: Router,) {}

  ngOnInit(): void {
    this.initializeGridColumns();
  }

  private formatCurrencyOrEmpty(value: any): string {
    const amount = Number(value ?? 0);
    return amount === 0 || isNaN(amount) ? '' : this.helperService.formatCurrency(amount);
  }

  private initializeGridColumns(): void {
    this.creditsGridColumns = [
      {
        headerName: 'Obligation No', field: 'paymentReferenceNo', sortable: true, filter: 'agTextColumnFilter', minWidth: 175
      },
      {
        headerName: 'IBRA Subregion', field: 'credit.ibraSubregion', sortable: true, filter: 'agTextColumnFilter', minWidth: 175
      },
      {
        headerName: 'Credit category', field: 'credit.creditCategory', sortable: true, filter: 'agTextColumnFilter', minWidth: 125
      },
      {
        headerName: 'Credit type ID', field: 'credit.creditTypeId', sortable: true, filter: 'agTextColumnFilter', minWidth: 125
      },
      {
        headerName: 'Offset trading group', field: 'credit.offsetTradingGroup', sortable: true, filter: 'agTextColumnFilter', minWidth: 250
      },
      {
        headerName: 'HBT status', field: 'credit.hbt', sortable: true, filter: 'agTextColumnFilter', minWidth: 100,
        valueFormatter: params => params.value === true ? 'Present' : 'Absent'
      },
      {
        headerName: 'No. of BAM Credits', field: 'credit.totalCredits', sortable: true, filter: 'agTextColumnFilter', minWidth: 150, type: 'rightAligned'
      }
    ];

    this.oldPaymentsGridColumns = [
      {
        headerName: 'Obligation No', field: 'paymentReferenceNo', sortable: true, filter: 'agTextColumnFilter', minWidth: 175,
        cellStyle: (params: any) => params.node.rowPinned ? { fontWeight: '700', textAlign: 'right' } : null,
        colSpan: (params: any) => {
          if (!params.node.rowPinned) {
            return 1;
          }
          return 9;
        }
      },
      {
        headerName: 'No. of BAM Credits', field: 'credit.totalCredits', sortable: true, filter: 'agTextColumnFilter', minWidth: 150, type: 'rightAligned'
      },
      {
        headerName: 'Predicted price per credit (Exc.GST)', valueGetter: (params: any) => this.helperService.formatCurrency(params.data.price != null ? params.data.price.predictedPrice : 0), sortable: true, filter: 'agTextColumnFilter', minWidth: 175, type: 'rightAligned'
      },
      {
        headerName: 'Risk premium per credit (Exc.GST)', valueGetter: (params: any) => this.helperService.formatCurrency(params.data.price != null ? params.data.price.riskPremium : 0), sortable: true, filter: 'agTextColumnFilter', minWidth: 175, type: 'rightAligned'
      },
      {
        headerName: 'Delivery fee per credit (Exc.GST)', valueGetter: (params: any) => this.helperService.formatCurrency(params.data.price != null ? params.data.price.deliveryFee : 0), sortable: true, filter: 'agTextColumnFilter', minWidth: 150, type: 'rightAligned'
      },
      {
        headerName: 'Monthly Indexation per Credit (Exc.GST)', valueGetter: (params: any) => this.helperService.formatCurrency(params.data.monthlyIndexationPerCredit != null ? params.data.monthlyIndexationPerCredit : 0), sortable: true, filter: 'agTextColumnFilter', minWidth: 200, type: 'rightAligned'
      },
      {
        headerName: 'No. of months lapsed', valueGetter: (params: any) => params.data.monthsLapsed != null ? params.data.monthsLapsed : '0', sortable: true, filter: 'agTextColumnFilter', minWidth: 175
      },
      
      {
        headerName: 'Indexation per Credit (Exc.GST)', valueGetter: (params: any) => this.helperService.formatCurrency(params.data.indexationPerCredit != null ? params.data.indexationPerCredit : 0), sortable: true, filter: 'agTextColumnFilter', minWidth: 200, type: 'rightAligned'
      },
      {
        headerName: 'Payment per credit (Exc. GST)', valueGetter: (params: any) => this.helperService.formatCurrency(params.data.price != null ? params.data.price.paymentPerCredit : 0), sortable: true, filter: 'agTextColumnFilter', minWidth: 225
      },
      {
        headerName: 'Total obligation payment (Exc.GST)', field: 'totalObligationPayment', valueGetter: (params: any) => {
          const amount = params?.data?.totalObligationPayment ?? params?.data?.totalObligation ?? params?.data?.price?.totalPrice ?? 0;
          return this.helperService.formatCurrency(amount);
        }, sortable: true, filter: 'agTextColumnFilter', minWidth: 200, type: 'rightAligned',
        cellStyle: (params: any) => params.node.rowPinned ? { fontWeight: 'bold' } : null
      }
    ];

    this.newPaymentsGridColumns = [
      {
        headerName: 'Obligation No', field: 'paymentReferenceNo', sortable: true, filter: 'agTextColumnFilter', minWidth: 175,
        cellStyle: (params: any) => params.node.rowPinned ? { fontWeight: '700', textAlign: 'right' } : null,
        colSpan: (params: any) => {
          if (!params.node.rowPinned) {
            return 1;
          }
          // In amended mode, do not span pinned rows so totals can show in intermediate columns.
          if (this.isRFQAfterAmendment) {
            return 8;
          }
          return 7;
        }
      },
      {
        headerName: 'No. of BAM Credits', field: 'credit.totalCredits', sortable: true, filter: 'agTextColumnFilter', minWidth: 150, type: 'rightAligned'
      },
      {
        headerName: 'Predicted price per credit (Exc.GST)', valueGetter: (params: any) => this.helperService.formatCurrency(params.data.price != null ? params.data.price.predictedPrice : 0), sortable: true, filter: 'agTextColumnFilter', minWidth: 175, type: 'rightAligned'
      },
      {
        headerName: 'Risk premium per credit (Exc.GST)', valueGetter: (params: any) => this.helperService.formatCurrency(params.data.price != null ? params.data.price.riskPremium : 0), sortable: true, filter: 'agTextColumnFilter', minWidth: 175, type: 'rightAligned'
      },
      {
        headerName: 'Delivery fee per credit (Exc.GST)', valueGetter: (params: any) => this.helperService.formatCurrency(params.data.price != null ? params.data.price.deliveryFee : 0), sortable: true, filter: 'agTextColumnFilter', minWidth: 150, type: 'rightAligned'
      },
      {
        headerName: 'External fee per credit (Exc.GST)', valueGetter: (params: any) => this.helperService.formatCurrency(params.data.price != null ? params.data.price.externalFeePerCredit : 0), sortable: true, filter: 'agTextColumnFilter', minWidth: 150, type: 'rightAligned'
      },
      {
        headerName: 'Predicted price (GST Payable)', field:'params.data.price.totalPrice', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        valueFormatter: (params: any) => this.formatCurrencyOrEmpty(params?.data?.price?.totalPrice),
        type: 'rightAligned'
      },
      {
        headerName: 'Risk premium (GST Payable)', field:'params.data.price.totalRiskPremium', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        valueFormatter: (params: any) => this.formatCurrencyOrEmpty(params?.data?.price?.totalRiskPremium),
        type: 'rightAligned'
      },
      {
        headerName: 'Obligation payment excluding fees (GST Payable)', valueGetter: (params: any) => this.formatCurrencyOrEmpty(params?.data?.price?.totalpredictedPrice), sortable: true, filter: 'agTextColumnFilter', minWidth: 225, type: 'rightAligned'
      },
      {
        headerName: 'Delivery costs - Per credit and fixed fee(GST payable)', valueGetter: (params: any) => this.formatCurrencyOrEmpty(params?.data?.price?.totalDeliveryFee), sortable: true, filter: 'agTextColumnFilter', minWidth: 225, type: 'rightAligned'
      },
      {
        headerName: 'Delivery costs - External fee (Non-GST)', valueGetter: (params: any) => this.formatCurrencyOrEmpty(params?.data?.price?.totalExternalFee), sortable: true, filter: 'agTextColumnFilter', minWidth: 225, type: 'rightAligned'
      },
      {
        headerName: 'Total obligation payment (Exc.GST)', field: 'totalObligationPayment', valueGetter: (params: any) => this.formatCurrencyOrEmpty(params?.data?.price?.totalPayment), sortable: true, filter: 'agTextColumnFilter', minWidth: 200, type: 'rightAligned',
        cellStyle: (params: any) => params.node.rowPinned ? { fontWeight: 'bold' } : null
      }
    ];

    this.paymentsGridColumns = this.oldPaymentsGridColumns;
  }

  get issuedDate(): string {
    return this.application && this.application.issuedDate ? this.helperService.dateFormat(this.application.issuedDate, "DD/MM/YYYY") : '';
  }

  get monthsLapsed(): string {
    const monthsLapsed = this.quoteStatement && this.quoteStatement.credits != null  && this.quoteStatement.credits.length > 0 ? 
    this.quoteStatement.credits[0].monthsLapsed : 0;
    return monthsLapsed.toString();
  }

  get applicantName(): string {
    return this.applicant && this.applicant.firstName ? this.applicant.firstName : '';
  }

  get developmentName(): string {
    const devName = this.obligationPayment?.projectName;
    return devName ? devName : (this.application && this.application.developmentName ? this.application.developmentName : '');
  }

  get status(): string {
    if (this.obligationPayment.status == RTMPApplicationStatus['InProgress']) return "In Progress";
    else if (this.obligationPayment.status == RTMPApplicationStatus['Cancelled']) return "Application cancelled";
    else if (this.obligationPayment.status == RTMPApplicationStatus['Draft']) return "Draft application";
    else if (this.obligationPayment.status == RTMPApplicationStatus['Completed']) return "Application completed";
    else return this.obligationPayment.status
  }

  get category(): string {
    if (this.application.category == "SP") return "Small Project";
    else if (this.application.category == "LP") return "Large Project";
    else return this.application.category
  }

  get applicationDate(): string {
    return this.obligationPayment && this.obligationPayment.paymentApplicationDateReceived ? this.helperService.dateFormat(this.obligationPayment.paymentApplicationDateReceived, "DD/MM/YYYY") : '';
  }

  get certificateIssueDate(): string {
    return this.obligationPayment && this.obligationPayment.certificateIssuedDate ? this.helperService.dateFormat(this.obligationPayment.certificateIssuedDate, "DD/MM/YYYY") : '';
  }

  get paymentReceiptDate(): string {
    return this.obligationPayment && this.obligationPayment.paymentReceivedDate ? this.helperService.dateFormat(this.obligationPayment.paymentReceivedDate, "DD/MM/YYYY") : '';
  }

  get paymentReceiptRecordNo(): string {
    return this.obligationPayment && this.obligationPayment.paymentReceiptNumber ? this.obligationPayment.paymentReceiptNumber : '';
  }


  get showDownloadCertificate(): boolean {
    return this.obligationPayment != null && 
          this.obligationPayment.certificateIssuedDate != null
          && this.isCertificateMailSent
           ? true : false;
  }

  open(id: number, paymentNumber: string, paymentId: number, quoteId: number): void {
    this.id = id;
    this.quoteId = quoteId || 0;
    this.paymentNumber = paymentNumber || '';
    this.paymentId = paymentId || 0;
    this.isCertificateMailSent = false;
    this.loadLookups();
    this.loadApplication(this.quoteId);
    
  }

   loadLookups() {

    //get file types
    const quoteFileTypeClassification = [this.FILE_TYPE_CODE];
    this.lookup.getClassifications(quoteFileTypeClassification).subscribe(results => {
      this.fileTypes = results;
    });

    //get LGAs;
    this.lookup.getLGAs().subscribe((results: any) => { this.lgas = results; });

    //get development types
    this.lookup.getDevelopmentTypes().subscribe((results: any) => { this.developmentTypes = results });

    this.quoteService.getQuoteRegisterSettings().subscribe((settings: any[]) => {
      const find = (code: string) => settings.find((s: any) => s.code === code);
      this.bcfPaymentFee = find('QTEBCFFEE')?.decimalValue ?? 0;
    });

  }

  loadApplication(id: number): void {
    if (id == null || id == undefined) {
      return;
    }

    const statement$ : Observable<any>= Number.isFinite(this.paymentId) && this.paymentId > 0
      ? this.quoteService.getQuoteStatementForPaymentById(id, this.paymentId)
      : this.quoteService.getQuoteStatement(id);

     const obligations$ = this.paymentService.getObligations(this.paymentId);    
      
    

    forkJoin({ statement: statement$, obligations: obligations$, application: this.quoteService.get(id) }).subscribe(({ statement, obligations, application }) => {
      this.application = application;
      this.quoteStatement = statement;
   
      this.isRFQAfterAmendment = !!application.isRFQAfterAmendment;
      this.paymentsGridColumns = this.isRFQAfterAmendment ? this.newPaymentsGridColumns : this.oldPaymentsGridColumns;

      // Use statement credits (they contain price data needed for totals)
      let quoteCredits = statement?.credits ?? statement;
      this.quoteCredits = quoteCredits;
      if(obligations && obligations.length > 0) {
        this.quoteCredits = obligations;
        (this.quoteCredits || []).forEach((credit: any) => {
          let quoteCredit = quoteCredits.find((qc: any) => qc.referenceNumber === credit.quoteObligationNumber);
          credit.price.predictedPrice = quoteCredit?.price?.predictedPrice ?? 0;
          credit.price.riskPremium = quoteCredit?.price?.riskPremium ?? 0;
          credit.referenceNumber = credit.bcfObligationNumber;
        });        
      }
      else{
        (this.quoteCredits || []).forEach((item: any) => {
          item.referenceNumber = item.paymentReferenceNo;
          if (item.monthsLapsed != null && item.monthlyIndexationPerCredit != null) {
            item.indexationPerCredit = item.monthsLapsed * item.monthlyIndexationPerCredit;
          }
        });
      }

      this.setQuoteCreditsPinnedTotalRow();

      if (this.paymentId > 0) {
        this.obligationPayment = application.obligationPayments.find((payment: any) => payment.id === this.paymentId) || {};
        this.payerSameAsApplicant = true;
  
        if (this.obligationPayment.id > 0) {
          this.paymentService.certificateMailSent(this.obligationPayment.id).subscribe((result: boolean) => {
            this.isCertificateMailSent = result;
          });
        }

        if(this.obligationPayment.applicantId != null && this.obligationPayment.payerId != null) {
          this.payerSameAsApplicant = this.obligationPayment.applicantId === this.obligationPayment.payerId;
        }

        const applicantId = this.obligationPayment?.applicantId;
        if(applicantId != application?.applicantId) {
          this.quoteService.getApplicant(applicantId).subscribe((applicant: any) => {            
            this.applicant = applicant;
          });
        }

        if(!this.payerSameAsApplicant && this.obligationPayment.payerId != null) {
          this.quoteService.getApplicant(this.obligationPayment.payerId).subscribe((payer: any) => {            
            this.payer = payer;
          });
        }
      }

      this.modalReference = this.modalService.open(this.modalContent, { ariaLabelledBy: 'modal-basic-title', size: 'xl', backdrop: 'static' });
    });
  }

  private setQuoteCreditsPinnedTotalRow(): void {
    const result: any[] = [];

    if (this.isRFQAfterAmendment) {
      let totalPriceExclFee = 0;
      let totalDeliveryFeeExclGst = 0;
      let externalFeeTotal = 0;
      const fixedExternalFee = this.quoteCredits && this.quoteCredits.length > 0 && this.bcfPaymentFee != null ? this.bcfPaymentFee : 0;

      (this.quoteCredits || []).forEach((credit: any) => {
        const totalCredits = Number(credit?.credit?.totalCredits ?? 0);
        const predictedPrice = Number(credit?.price?.predictedPrice ?? 0);
        const riskPremium = Number(credit?.price?.riskPremium ?? 0);
        const deliveryFee = Number(credit?.price?.deliveryFee ?? 0);
        const externalFeePerCredit = Number(credit?.price?.externalFeePerCredit ?? 0);

        totalPriceExclFee += Number(credit?.price?.totalpredictedPrice ?? 0);
        totalDeliveryFeeExclGst += Number(credit?.price?.totalDeliveryFee ?? 0);
        externalFeeTotal += Number(credit?.price?.totalExternalFee ?? 0);

        const deliveryFeePerCredit = (credit?.price?.deliveryFee != null ? credit.price.deliveryFee : 0);
        
        credit.price.externalFeePerCredit = externalFeePerCredit;
        credit.price.deliveryFee = deliveryFeePerCredit;
        credit.price.totalpredictedPrice = totalCredits * (credit.price.predictedPrice+credit.price.riskPremium);
        credit.price.totalRiskPremium = totalCredits * credit.price.riskPremium;

        credit.price.totalPriceExclFee = credit.price.totalpredictedPrice + credit.price.totalRiskPremium;
        credit.price.totalExternalFee = totalCredits * externalFeePerCredit;
        credit.price.totalDeliveryFee = totalCredits * deliveryFeePerCredit;
        credit.price.totalPayment = credit.price.totalpredictedPrice + credit.price.totalExternalFee + credit.price.totalDeliveryFee;
        credit.price.bcfPaymentFee = this.bcfPaymentFee;
      });

      const totalPaymentExclFeeGst = totalPriceExclFee * 0.10;
      const totalPaymentExclFeeInclGst = totalPriceExclFee + totalPaymentExclFeeGst;

      const totalDeliveryFeeGst = (totalDeliveryFeeExclGst + fixedExternalFee) * 0.10;
      const totalDeliveryFeeInclGst = totalDeliveryFeeExclGst + totalDeliveryFeeGst;

      const totalExternalFeeGst = 0;
      const totalExternalFeeInclGst = externalFeeTotal + totalExternalFeeGst;

      const fixedFeeRow = {
        paymentReferenceNo: 'Delivery cost - Fixed fee',
        price: {
          totalpredictedPrice: 0,
          totalDeliveryFee: fixedExternalFee,
          totalExternalFee: 0,
          totalPayment: fixedExternalFee
        }
      };

      const totalWithoutGstRow = {
        paymentReferenceNo: 'Total payment (Excluding GST)',
        price: {
          totalpredictedPrice: totalPriceExclFee,
          totalDeliveryFee: totalDeliveryFeeExclGst + fixedExternalFee,
          totalExternalFee: externalFeeTotal,
          totalPayment: totalPriceExclFee + totalDeliveryFeeExclGst + externalFeeTotal + fixedExternalFee
        }
      };

      const totalGstRow = {
        paymentReferenceNo: 'Total GST',
        price: {
          totalpredictedPrice: totalPaymentExclFeeGst,
          totalDeliveryFee: totalDeliveryFeeGst,
          totalExternalFee: totalExternalFeeGst,
          totalPayment: totalPaymentExclFeeGst + totalDeliveryFeeGst + totalExternalFeeGst
        }
      };

      const totalWithGstRow = {
        paymentReferenceNo: 'Total payment (Including GST)',
        price: {
          totalpredictedPrice: totalPaymentExclFeeInclGst,
          totalDeliveryFee: totalDeliveryFeeInclGst + fixedExternalFee,
          totalExternalFee: totalExternalFeeInclGst,
          totalPayment: totalPaymentExclFeeInclGst + totalDeliveryFeeInclGst + fixedExternalFee + totalExternalFeeInclGst
        }
      };

      result.push(fixedFeeRow);
      result.push(totalWithoutGstRow);
      result.push(totalGstRow);
      result.push(totalWithGstRow);
    } else {
      
      let totalPaymentExcludingGst: number = this.quoteStatement?.totalPaymentExcludingGST ? Number(this.quoteStatement.totalPaymentExcludingGST) : 0;
      let totalGst: number = this.quoteStatement?.gstAmount ? Number(this.quoteStatement.gstAmount) : 0;
      let totalPaymentIncludingGst: number = this.quoteStatement?.totalPaymentIncludingGST ? Number(this.quoteStatement.totalPaymentIncludingGST) : 0;

      if (totalPaymentExcludingGst === 0 && totalGst === 0 && totalPaymentIncludingGst === 0) {
        totalPaymentExcludingGst = (this.quoteCredits || []).reduce((sum, item) => {
          const amount = item && item.price && item.price.totalPrice ? Number(item.price.totalPrice) : 0;
          return sum + (isNaN(amount) ? 0 : amount);
        }, 0);
        totalGst = totalPaymentExcludingGst * 0.01;
        totalPaymentIncludingGst = totalPaymentExcludingGst + totalGst;
      }

      result.push({
        paymentReferenceNo: 'Total (Exc. GST)',
        price: {
          totalPrice: totalPaymentExcludingGst
        }
      });

      result.push({
        paymentReferenceNo: 'GST',
        price: {
          totalPrice: totalGst
        }
      });

      result.push({
        paymentReferenceNo: 'Total (Inc. GST)',
        price: {
          totalPrice: totalPaymentIncludingGst
        }
      });
    }

    this.totalPinnedBottomRowData = result;

    if (this.gridApi) {
      this.gridApi.setPinnedBottomRowData(this.totalPinnedBottomRowData);
    }
  }

  close(): void {
    if (this.modalReference) {
      this.modalReference.close();
    }
  }

  public downloadRTMP() {
    this.fileService.downloadRTMP(this.paymentId,this.application?.referenceNumber);
  }

  public downloadCertificate() {
    this.fileService.downloadCertificate(this.paymentId, this.paymentNumber);
  }

  public uploadAdditionalDocuments(): void {
  }

  public requestToMakePayment(): void {
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.setQuoteCreditsPinnedTotalRow();
    this.gridApi.sizeColumnsToFit();
  }

  public getPaymentsRowStyle = (params: any) => {
    return params.node && params.node.rowPinned ? { fontWeight: '700' } : null;
  }


}
